@if (iframeUrl(); as url) {
  <iframe
    [src]="url"
    (load)="onLoadData($event)"
    (error)="onError($event)"
    class="player"
  ></iframe>
}
